import { CONFIG } from './config'

export const WORDS = [
  "t'esil",
  "kwiyos",
  "ximel",
  "theqat",
  "kwoxwet",
  "sta'a",
  "siyam",
  "xwelp't",
  "kwekwat",
  "xopem",
  "petam",
  "okw'est",
  "sx̲wōsem",
  "sq'eq'o",
  "chichelh",
  "ts'its'etl'",
  "liyem",
  "yox̲wet",
  "p'ōwiyt",
  "sqemo",
  "shxweway",
  "iyotht",
  "hiyot",
  "heyeqw",
  "xaq'em",
  "qeloth",
  "q'eyt'o",
  "meqw'et",
  "qeth'et",
  "yelx̲t",
  "th'ax̲ey",
  "sts'axt",
  "q'elem",
  "kw'itsel",
  "xipet",
  "q'pels",
  "ts'ets'at",
  "qiqew",
  "q'oyits",
  "sawel",
  "sts'ets'a",
  "olthet",
  "owthet",
  "ex̲qst",
  "pokw'em",
  "p'ath'et",
  "kw'ithet",
  "x̲poys",
  "t'eqw'ot",
  "tl'iq'el",
  "qwiqwex̲w",
  "q'ix̲el",
  "sth'ololh",
  "tawel",
  "q'oq'iy",
  "x̲ex̲elh",
  "sp'lhiq'",
  "lemet",
  "yeqwil",
  "th'tame",
  "yeltht",
  "th'awem",
  "selix",
  "potem",
  "lhits'et",
  "qemot",
  "skw'alx̲",
  "ts'kw'xos",
  "teqap",
  "xwothet",
  "semikw'",
  "lhelqt",
  "x̲we'at",
  "yit'et",
  "ch'iyaq",
  "tl'etl'ot",
  "x̲woqw'et",
  "kw'iyat",
  "eqw'ils",
  "temes",
  "lhoyel",
  "x̲eylt",
  "chayxwt",
  "xwikw'el",
  "q'oq'ey",
  "shxwteli",
  "q'awet",
  "x̲wetat",
  "stuxws",
  "lex̲et",
  "q'ap'et",
  "sixalh",
  "kw'oyekw",
  "sikw'et",
  "lhimes",
  "tosem",
  "kw'emet",
  "xelokw'",
  "x̲eyet",
  "xwlala",
  "chelhta",
  "ts'ats'el",
  "qaqiw",
  "qw'iwelh",
  "t'emeqw'",
  "qw'ats'et",
  "kwatsem",
  "sax̲em",
  "q'axil",
  "mitl'et",
  "walhet",
  "ts'iwel",
  "t'ilem",
  "th'ikwem",
  "tl'its'et",
  "chelexw",
  "pesk'a",
  "qw'oqw'el",
  "x̲wiqw'el",
  "elile",
  "x̲wex̲wet",
  "lheq'elh",
  "stl'exs",
  "six̲et",
  "th'iqw'et",
  "kwiyx̲t",
  "shxwiyos",
  "kw'ekw'em",
  "spalxw",
  "xwiyos",
  "xwiyoth",
  "q'elpt",
  "sikw'em",
  "poqw'elh",
  "pixwem",
  "th'eth'at",
  "lekli",
  "th'aq'em",
  "yelqw't",
  "telhat",
  "miset",
  "q'othet",
  "otheqwt",
  "yewal",
  "q'elets'",
  "toqw'em",
  "sqw'els",
  "lhetqwt",
  "lepet",
  "qolem",
  "iwest",
  "ts'ilem",
  "xalet",
  "q'eq'ey",
  "qoqem",
  "t'at'elh",
  "mesil",
  "pikwel",
  "x̲ex̲akw'",
  "lhelhos",
  "mot'es",
  "sitel",
  "kw'okw'iy",
  "t'apet",
  "tl'elexw",
  "txwoye",
  "t'elkw't",
  "istexw",
  "kwixet",
  "lhemexw",
  "lhax̲em",
  "th'eq'em",
  "soles",
  "q'alets",
  "kw'ikw'exw",
  "x̲t'als",
  "lakw'em",
  "melxwt",
  "kw'axem",
  "chechoxw",
  "kw'elhst",
  "qelat",
  "qwiqwiy",
  "mathxwi",
  "liqwem",
  "p'ith'et",
  "th'oyeqw",
  "x̲oqel",
  "meq'et",
  "kwelex",
  "chekel",
  "swiwe",
  "leput",
  "kwokwel",
  "tamexw",
  "yoyes",
  "qolhcha",
  "smilha",
  "seltl'o",
  "piyet",
  "q'eylom",
  "sq'eykw'",
  "t'at'em",
  "lekw'ot",
  "th'ewil",
  "ts'q'eyx̲",
  "syoys",
  "kweltol",
  "helkw't",
  "teset",
  "xwithet",
  "xwalexw",
  "xaxem",
  "p'xwelhp",
  "theq'et",
  "leq'alh",
  "eyaqt",
  "yoswe",
  "xileqw",
  "thothel",
  "s'ox̲we",
  "syuwe",
  "lhalhil",
  "eweta",
  "t'amet",
  "x̲elts't",
  "pelekw",
  "sts'alts'",
  "wex̲es",
  "x̲ix̲wom",
  "qwelats",
  "th'etset",
  "wayel",
  "xwemax",
  "yiyeq",
  "x̲esel",
  "ch'axwel",
  "lex̲wet",
  "kwosel",
  "satet",
  "kwelat",
  "shxwoxwel",
  "alwem",
  "sqweqwa",
  "kw'aset",
  "tsmela",
  "s'atl'q",
  "sth'omes",
  "q'aq'iw",
  "qwoqwel",
  "lhex̲wot",
  "th'oqwet",
  "sqawth",
  "xokw'em",
  "isalhp",
  "t'emel",
  "kw'atem",
  "q'ox̲el",
  "silis",
  "thits'et",
  "helem",
  "seq'et",
  "weltil",
  "t'et'at",
  "lepot",
  "atl'qel",
  "x̲ep'ekw'",
  "sth'ikwe",
  "sth'okws",
  "xiyts't",
  "qw'imet",
  "malyi",
  "ts'ayxwt",
  "lep'ex",
  "q'owet",
  "xwixwel",
  "xaweq",
  "xwe'it",
  "speqas",
  "lhets'am",
  "tl'epil",
  "p'ith'em",
  "tl'ex̲wet",
  "liqwel",
  "t'elem",
  "q'eyos",
  "wiqes",
  "pumil",
  "kw'atset",
  "lhikw'et",
  "qeytl't",
  "th'olhem",
  "sq'alq'",
  "piwet",
  "kw'itset",
  "lheq'at",
  "sq'elp",
  "qwe'op",
  "t'akw'el",
  "sth'oqwi",
  "xwilex",
  "thiyem",
  "qw'oqwet",
  "qetx̲t",
  "ch'amet",
  "silaw",
  "p'ep'it",
  "hoqwem",
  "yoseqw",
  "aylexw",
  "th'iset",
  "yekw'es",
  "th'eth'ex̲",
  "q'owet",
  "x̲epkw't",
  "slhali",
  "t'et'eqw'",
  "qwix̲wet",
  "xwelekw'",
  "p'tl'omt",
  "ts'ekwx̲t",
  "x̲alew",
  "qewet",
  "t'othet",
  "t'amex",
  "shxwti'ala",
  "skoti",
  "slehal",
  "hilekw",
  "x̲och'alh",
  "ts'qw'ela",
  "tuxwes",
  "skw'atets",
  "th'ikwekw",
  "lomet",
  "lewalh",
  "kw'iles",
  "qoqet",
  "hekw'elh",
  "tl'oth'et",
  "tsmele",
  "popekw'",
  "yeyaq'",
  "kw'oqwet",
  "sqwomx̲w",
  "lhqola",
  "sokw'em",
  "wath'elh",
  "p'ip'ex̲w",
  "lets'et",
  "t'iqel",
  "x̲asaxw",
  "lhxwale",
  "silixw",
  "x̲eyx̲am",
  "pakw'et",
  "qwiqwelh",
  "sxelts'",
  "st'ayx̲w",
  "lhelqi",
  "sayt't",
  "moqwem",
  "p'oth'es",
  "qwayx̲t",
  "lemat",
  "lepal",
  "p'oqw'em",
  "qwelhat",
  "q'emos",
  "swilhcha",
  "epale",
  "spiyem",
  "p'ep'ilh",
  "kw'at'el",
  "tselqt",
  "tl'x̲wiws",
  "p'aq'em",
  "sayem",
  "wiyoth",
  "selikw",
  "towel",
  "yaq'et",
  "yit'em",
  "p'ep'ekw",
  "miq'et",
  "kwtaxwt",
  "kwotel",
  "laxel",
  "kw'okw'es",
  "smeya",
  "leqem",
  "lolem",
  "t'otexw",
  "t'oqwel",
  "lholhes",
  "kw'otl'kwa",
  "yelolh",
  "sesiq'",
  "th'atsem",
  "thekw'et",
  "q'elhal",
  "th'ath'em",
  "six̲wem",
  "tatiy",
  "luste",
  "kwomexw",
  "yemq't",
  "shxw'aye",
  "q'eyex̲",
  "x̲eqet",
  "timet",
  "xits'em",
  "kw'esam",
  "sx̲eytl'",
  "toset",
  "hasem",
  "qwelst",
  "siqw'em",
  "moqwem",
  "yeyex̲w",
  "shxwelem",
  "the'it",
  "ts'imet",
  "kw'siws",
  "p'ewiy",
  "xwixwes",
  "qweset",
  "lalem",
  "athelets",
  "qelem",
  "lewex",
  "x̲olem",
  "swiqe",
  "atsele",
  "q'otel",
  "kw'elalh",
  "sq'x̲ap",
  "yothet",
  "tselil",
  "smotx̲w",
  "tl'itl'ew",
  "potem",
  "mekw'et",
  "xokw'et",
  "kekway",
  "sqwoyxw",
  "tetath",
  "yokw'et",
  "th'oqw'em",
  "chachelh",
  "selolh",
  "xwewil",
  "spils",
  "qweqwis",
  "hitel",
  "sisem",
  "thomel",
  "liyom",
  "temexw",
  "mekw'em",
  "x̲wiqw'em",
  "lax̲et",
  "ts'asem",
  "meles",
  "sewip",
  "yekw'et",
  "yetl'q't",
  "q'elq't",
  "wep'eth'",
  "kechel",
  "th'ex̲wot",
  "wiqet",
  "px̲wiqs",
  "xwewes",
  "tl'alhem",
  "qw'elem",
  "xwalp't",
  "thethexw",
  "q'ixwet",
  "latelh",
  "lhelheqw'",
  "lhit'et",
  "isale",
  "x̲wiyam",
  "ts'qw'elhp",
  "semyo",
  "maq'em",
  "q'oleq",
  "sqwels",
  "t'opet",
  "alhqay",
  "st'alq",
  "plist",
  "loqwet",
  "thethex̲",
  "yoqw'em",
  "ts'qols",
  "lesak",
  "qites",
  "qemel",
  "ts'isem",
  "lhoqw'et",
  "sq'eytl'",
  "sx̲ewe",
  "qaqem",
  "pelqw't",
  "kwe'at",
  "tewit",
  "qwoyel",
  "tl'emeqw",
  "xetem",
  "almelh",
  "hilexw",
  "schexwem",
  "qweqwes",
  "th'ex̲et",
  "xwoyem",
  "sch'olha",
  "yex̲wet",
  "chaket",
  "hilex",
  "mamel",
  "sqels",
  "yix̲wet",
  "qw'emet",
  "lothel",
  "qw'eqw'el",
  "thq'als",
  "ix̲est",
  "pathet",
  "qelexw",
  "t'itsem",
  "ts'iyelh",
  "smalt",
  "qalets'",
  "kwelexw",
  "wothel",
  "leqwot",
  "t'omel",
  "thex̲oth",
  "yayeq'",
  "qw'iles",
  "ikw'elo",
  "q'owem",
  "qiq'et",
  "xwiqwet",
  "slhqw'ay",
  "yeyix̲w",
  "tewat",
  "aletse",
  "thex̲et",
  "sox̲wel",
  "kyoxalh",
  "maqel",
  "lhawet",
  "x̲ep'kw't",
  "pekcha",
  "slhixws",
  "lexet",
  "p'akw'et",
  "th'iwel",
  "lhemth't",
  "qetas",
  "yokw'em",
  "mekw'et",
  "xits'et",
  "t'ekwot",
  "t'et'as",
  "letam",
  "xchapth",
  "qw'iqw'em",
  "lileq",
  "polxwt",
  "lhemet",
  "ts'ets'eqw'",
  "pekw'em",
  "tl'epx̲t",
  "hokwex",
  "schiya",
  "liqw'em",
  "x̲eyx̲e",
  "ex̲wtel",
  "oxwest",
  "xitem",
  "s'eho",
  "lhaqem",
  "sx̲alts'",
  "p'otl'em",
  "liqwet",
  "eyqwlha",
  "lets'axw",
  "th'eset",
  "kw'ekw'os"
]

if (CONFIG.normalization) {
  WORDS.forEach((val, i) => (WORDS[i] = val.normalize(CONFIG.normalization)))
}

function shuffle(array: any[]) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }
}

if (CONFIG.shuffle) {
  shuffle(WORDS)
}
